import { getRefreshPromise } from 'app/http';
import { invalidateSession } from 'app/http/sessionInvalidation';
import { triggerBrowserDownload } from './jobLinkHelpers';

export const downloadViaBrowser = async (url: string, fileName: string) => {
  const refreshResult = await getRefreshPromise();
  if (refreshResult.kind === 'auth-failure') {
    invalidateSession({ broadcast: true });
    return;
  }
  triggerBrowserDownload(url, fileName);
};
